<template>
  <div class="public-content theme-management" ref="managementContent">
    <div class="region-title" style="background: #fff">活动管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0;font-weight: bold;">活动名称:</span>
        <el-input v-model="searchStoreVO.activityName" clearable placeholder="请输入活动名称"></el-input>
        <span style="margin:0 10px 0 20px;font-weight: bold;">活动状态 :</span>
        <el-select v-model="searchStoreVO.activityStatus" clearable placeholder="请选择">
          <el-option v-for="item in activityType" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, getTheme()">查询</el-button>
      </div>
    </div>
    <div class="data-list">
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border :row-class-name="rowClassName">
        <el-table-column min-width="100px" prop="activityName" label="活动名称"> </el-table-column>
        <el-table-column min-width="100px" prop="themeName" label="优惠信息">
          <template v-slot="scope">
            <div>
              <div v-for="item in scope.row.rules" :key="item.createdId"> 满{{ item.fullAmount }} {{ item.ladderDiscounts == 1 ? '元' : '件' }}，{{ item.ladderDiscounts == 4 ? '每件' : '' }}{{
                  item.ladderDiscounts == 2 ? '打' : '减'
              }}{{ item.discountAmount }}{{ item.ladderDiscounts == 2 ? '折' : '元' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="100px" prop="dateEnd" label="活动时间">
          <template v-slot="scope"> {{ scope.row.dateStart }}-{{ scope.row.dateEnd }} </template>
        </el-table-column>
        <el-table-column min-width="100px" prop="activityStatus" label="活动状态">
          <template v-slot="scope"> {{ scope.row.activityStatus == 'PROGRESSING' ? '进行中' : scope.row.activityStatus == 'NEW' ? '未开始' : scope.row.activityStatus == 'ENDED' ? '已结束' :
              scope.row.activityStatus == 'EXPIRED' ? '已失效' : ''
          }} </template>
        </el-table-column>
        <el-table-column min-width="200px" prop="themeName" label="活动产品">
          <template v-slot="scope"><span v-for="(item, index) in scope.row.spuXrefs" :key="item.spuId">{{ item.spuName }}<span
                v-show="index != scope.row.spuXrefs.length - 1">,</span></span></template>
        </el-table-column>
        <el-table-column min-width="100px" label="操作">
          <template v-slot="scope">
            <span class="color-blue" @click="changeList('编辑', scope.row)"
              v-if="(scope.row.activityStatus == 'PROGRESSING' || scope.row.activityStatus === 'NEW') && $hasPermission('pts:admin:discount:update')">编辑<br></span>
            <span class="color-blue" @click="changeList('查看', scope.row)">查看<br></span>
            <span class="color-blue" @click="changeList('复制', scope.row)">复制<br></span>
            <span class="color-blue" @click="expiredId = scope.row.id, loseDialog = true"
              v-if="(scope.row.activityStatus !== 'ENDED' && scope.row.activityStatus !== 'EXPIRED') && $hasPermission('pts:admin:discount:expired')">设为失效<br></span>
            <span class="color-blue" @click="deleteId = scope.row.id, deleteDialog = true"
              v-if="scope.row.activityStatus !== 'PROGRESSING' && $hasPermission('pts:admin:discount:delete')">删除<br></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 失效确认 -->
    <el-dialog :close-on-click-modal="false" title="失效确认" :visible.sync="loseDialog" width="30%">
      <span>确定将该活动设为失效？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loseDialog = false">取 消</el-button>
        <el-button type="primary" @click="changeList('失效', expiredId)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该活动？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="changeList('删除', deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { getActivityList, sampleAdd, sampleUpdate, sampleUsable, activityDelete, setExpired } from '@/api/pms'
export default {
  name: 'manage-fullreduction',
  components: {
    VPagination
  },
  data () {
    return {
      loseDialog: false,
      groupCategoryId: null,
      activityType: [{ id: 'NEW', name: '未开始' }, { id: 'PROGRESSING', name: '进行中' }, { id: 'ENDED', name: '已结束' }, { id: 'EXPIRED', name: '已失效' }],
      searchStoreVO: {
        activityName: '',
        page: 1
      },
      deleteId: '',
      expiredId: '',
      deleteDialog: false,
      title: '',
      choiceId: '',
      themeName: '',
      dialogVisible: false,
      tableData: [],
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      rememberScroll: null
    }
  },
  async mounted () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.searchStoreVO = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('offsetY')
    }
    await this.getTheme()
    this.$nextTick(() => {
      let that = this
      that.$refs.managementContent.addEventListener('scroll', that.handleScroll)
      // 根据本地缓存取出初始值并渲染页面
      that.rememberScroll = Number(sessionStorage.getItem('offsetY'))
      that.$refs.managementContent.scrollTo(0, that.rememberScroll)
    })
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
    if (this.rememberScroll) {
      sessionStorage.setItem('offsetY', this.rememberScroll)
      // console.log('rememberScroll=', this.rememberScroll)
    } else {
      sessionStorage.setItem('offsetY', 0)
    }
  },
  methods: {
    handleScroll (e) { // vue 方法中可直接加e获取event，当@click方法不加括号默认传event参数。      
      const target = e.target // 获取元素目标
      if (target) {
        this.rememberScroll = target.scrollTop// 获取离页面上方高度
        console.log(this.rememberScroll, 'handleScroll')
      } else {
        this.rememberScroll = 0
      }
    },
    addTheme () {
      if (this.themeName === '') {
        this.$message.error('请输入名称')
        return
      }
      if (this.type === 'edit') {
        sampleUsable({ act: 1, spuDictName: this.themeName }).then(res => {
          if (res.data.success) {
            sampleUpdate({ themeId: this.choiceId, themeName: this.themeName }).then(res => {
              if (res.data.success) {
                this.getTheme()
                this.$message.success('修改成功')
                this.dialogVisible = false
              }
            })
          }
        })
      } else if (this.type === 'add') {
        sampleUsable({ act: 0, spuDictName: this.themeName }).then(res => {
          if (res.data.success) {
            sampleAdd(this.themeName).then(res => {
              if (res.data.success) {
                this.getTheme()
                this.$message.success('添加成功')
                this.dialogVisible = false
              }
            })
          }
        })
      }
    },
    async getTheme () {
      let { pageNum, pageSize } = this.queryInfo
      await getActivityList({ pageNum: pageNum, pageSize: pageSize, searchStoreVO: this.searchStoreVO }).then((res) => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getTheme()
          }
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].operation = {
              edit: '编辑',
              delete: '删除'
            }
          }
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      // 把每一行的索引放进row
      row.index = rowIndex
      // this.tableData[rowIndex].index = rowIndex
    },
    changeList (val, content) {
      console.log('content', content)
      this.choiceId = content.id
      if (val === '失效') {
        setExpired(content).then(res => {
          if (res.data.success) {
            this.getTheme()
            this.$message.success('设置成功')
            this.loseDialog = false
          }
        })
      }
      if (val === '删除') {
        activityDelete(content).then(res => {
          if (res.data.success) {
            this.getTheme()
            this.$message.success('删除成功')
            this.deleteDialog = false
          }
        })
      }
      if (val === '编辑') {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.searchStoreVO))
        this.$router.push({
          path: '/createFullReduction',
          query: {
            id: this.choiceId,
            type: 'edit'
          }
        })
      }
      if (val === '复制') {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.searchStoreVO))
        this.$router.push({
          path: '/createFullReduction',
          query: {
            id: this.choiceId,
            type: 'copy'
          }
        })
      }
      if (val === '查看') {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.searchStoreVO))
        // this.title = '编辑主题'
        this.type = 'detail'
        this.$router.push({
          path: '/detailFullReduction',
          query: {
            id: this.choiceId
          }
        })
        // this.themeName = content.themeName
        // this.dialogVisible = true
      }
    },
    primaryAdd () {
    },
    addCategory () {
      this.getTheme(this.queryInfo)
    },
    changeName () {
      this.getTheme(this.queryInfo)
    },
    changePage (val) {
      this.queryInfo = val
      this.getTheme(this.queryInfo)
    },
    deleteTheme () {
      this.getTheme(this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
.theme-management {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  // overflow: auto;
  -webkit-overflow-scrolling: touch;

  // &::-webkit-scrollbar {
  //   display: none;
  // }
}

.add-category {
  justify-content: space-between;
}

.keywords {
  .el-input {
    width: 180px;
  }
}
</style>
